module.exports = __webpack_public_path__ + "img/LikeGreen.663a9f9a.png";